<script>
import BaseConfig from './base.vue'

export default {
  name: 'EventServicesAdd2Cart',

  extends: BaseConfig,
}
</script>
